import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

const baseUrl = `${process.env.REACT_APP_BASE_URL}/admin/`

export const authApiService = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({ baseUrl }),

  endpoints: (builder) => ({
    login: builder.mutation({
      query: (payload) => ({
        url: 'login',
        method: 'POST',
        body: { ...payload, device_id: localStorage.getItem("device_token") }
      })
    }),
    forgetPassword: builder.mutation({
      query: (payload) => ({
        url: '../auth/forget-password',
        method: 'POST',
        body: payload
      })
    }),
    verifyOtp: builder.mutation({
      query: (payload) => ({
        url: '../auth/verify-otp',
        method: 'POST',
        body: payload
      })
    }),
    resetPassword: builder.mutation({
      query: (payload) => ({
        url: '../auth/reset-password',
        method: 'POST',
        body: payload
      })
    })
  })
})

export const {
  useLoginMutation,
  useForgetPasswordMutation,
  useVerifyOtpMutation,
  useResetPasswordMutation
} = authApiService